import { RouteRecordRaw } from "vue-router";
import settingRouter from "./settingRouter";
import reportsRouter from "./reportsRouter";
import dailyMovementRouter from "./dailyMovementsRouter";

const SalariesRouters: Array<RouteRecordRaw> = [
  ...settingRouter,
  ...reportsRouter,
  ...dailyMovementRouter,
];

export default SalariesRouters;
